import { isValid, parseISO } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { Decimal } from 'decimal.js';
import * as Parse from './Parse.js';
import { ParseError } from './ParseError';
import { ParseResult } from './ParseResult';
import { ParseTree } from './ParseTree';
export var Parser;
(function (Parser) {
    function parse(source) {
        try {
            const root = Parse.parse(source, Parsers);
            if (root == null) {
                return ParseResult.failure(new ParseError.Empty());
            }
            else {
                return ParseResult.success(ParseTree.make(source, [root]), root);
            }
        }
        catch (err) {
            if (err instanceof Error) {
                if (err.name === 'SyntaxError') {
                    return ParseResult.failure(ParseError.make(err));
                }
            }
            throw err;
        }
    }
    Parser.parse = parse;
    let Parsers;
    (function (Parsers) {
        const timeDelimRe = /[T ]/;
        const timeZoneRe = /[+-]\d\d(?::?\d\d)?$/;
        const dateFormats = [
            'YYYY-MM-DD',
            'YYYY-MM-DD HH:mm:ss',
            'YYYY-MM-DDTHH:mm:ss.sssZ',
        ];
        Parsers.date = (source) => {
            let date = parseISO(source);
            if (isValid(date)) {
                if (source.includes('Z')) {
                    return date.getTime();
                }
                timeDelimRe.lastIndex = 0;
                if (timeDelimRe.test(source)) {
                    const [_, timePart] = source.split(timeDelimRe);
                    timeZoneRe.lastIndex = 0;
                    if (timeZoneRe.test(timePart)) {
                        return date.getTime();
                    }
                }
                date = zonedTimeToUtc(source, 'Z');
                if (isValid(date)) {
                    return date.getTime();
                }
            }
            const expected = dateFormats.join('#, #');
            return new Error(`Invalid date. Expected format to be one of: ` +
                `#${expected}#. Saw: #${source}#`);
        };
        Parsers.numeric = (source) => {
            const numValue = new Decimal(source);
            if (numValue.gte(Number.MIN_SAFE_INTEGER) &&
                numValue.lte(Number.MAX_SAFE_INTEGER)) {
                return numValue.toNumber();
            }
            return numValue;
        };
    })(Parsers = Parser.Parsers || (Parser.Parsers = {}));
})(Parser || (Parser = {}));
